/** NumberField reports an emptied input as '', and as a string when a mask is in play */
export const toBound = (fieldValue?: number | string): number | undefined => {
  if (fieldValue === undefined || fieldValue === '') return undefined;

  const bound = Number(fieldValue);

  return Number.isNaN(bound) ? undefined : bound;
};
